


 export default function Table({className,...props}) {
 
     return (
         <table className={`${className} w-full overflow-x-auto whitespace-no-wrap `}>
             {
                    props.children
             }

         </table>
         
     )
 }